export const isUrlThatRequireLogin = (to: string): boolean => {
  const DOMAINS_WHITELIST_REGEX = /^(https?:\/\/)?((?!claims?\.axa\.travel)[^.\/]+\.)*((frendglobal\.com)|(axa\.travel)|(telemedicine\.mytripcompanion\.us))\/?/i;
  return DOMAINS_WHITELIST_REGEX.test(to);
};
